import React, { FC, useContext } from 'react';

import { getRowHeight, getWrapperStyle } from './style-rows';
import { getRowHeightSize } from '../user-grid-settings/user-grid-settings-actions';
import { PredictionsAccountCategories } from '../../../../core/types';
import { RowAccount } from './rows/components/row-account';
import { RowType, TotalRow } from './types';
import { SIZES } from '../../../../core/constants';
import { useDataGridLayout } from '../../../../ui/data-grid/components/data-grid-layout-context';
import { UserGridSettingsContext } from '../user-grid-settings/user-grid-settings-context';

interface Props {
  totalRows: TotalRow[] | null;
  rowHeightOverride?: SIZES;
  showZeroAndHighlightForChart?: boolean;
  columns: string[];
  category?: PredictionsAccountCategories;
  chartCustomSettings?: { colors?: string[]; thinLines?: boolean; yesterday?: boolean };
  hideBudgetData?: boolean;
  autoScrollMarker?: boolean;
}

export const Rows: FC<Props> = ({
  rowHeightOverride = SIZES.X_LARGE,
  totalRows,
  showZeroAndHighlightForChart,
  columns,
  category,
  chartCustomSettings,
  hideBudgetData = false,
  autoScrollMarker = false
}: Props) => {
  const { rowHeights, showDecimals } = useContext(UserGridSettingsContext);
  const dataGridLayout = useDataGridLayout();
  const rowHeight = getRowHeightSize(rowHeights);
  const forceLargeRowHeights = { default: rowHeightOverride };

  const getRowStyle = (index: number, totalRow: RowType) => ({
    ...getWrapperStyle(index, {}, rowHeightOverride, totalRow, true),
    height: hideBudgetData ? 1 : getRowHeight(index, forceLargeRowHeights, totalRow, true),
    width: '100%'
  });

  if (!totalRows) {
    return null;
  }

  return (
    <div role="grid" style={dataGridLayout ? { width: dataGridLayout.contentWidth } : undefined}>
      {totalRows.map((totalRow, index) => (
        <div
          style={getRowStyle(index, totalRow)}
          key={`${totalRow.account?.index || totalRow.section}_total_row`}
          role="row"
        >
          <RowAccount
            row={{ ...totalRow, isMainHeadline: true }}
            rowHeight={rowHeight}
            showDecimals={showDecimals}
            rowHeightOverride={rowHeightOverride}
            level={totalRow.level}
            showZeroAndHighlightForChart={showZeroAndHighlightForChart}
            columns={columns}
            category={category}
            chartCustomSettings={chartCustomSettings}
            hideBudgetData={hideBudgetData}
            autoScrollMarker={autoScrollMarker}
          />
        </div>
      ))}
    </div>
  );
};
